import React from 'react'
import ReactSelect from 'react-select'
import styles from './FontWeightInput.module.css' // Assurez-vous de mettre à jour le chemin du fichier CSS

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 300ms'

    return {
      ...provided,
      opacity,
      transition,
      color: 'var(--dark-gray)',
      fontSize: 'var(--size-font-input)',
      fontFamily: 'var(--sans-serif)',
      fontWeight: state.data.value, // Utilisez la valeur de l'option comme poids de police
    }
  },
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)', // Changer la couleur d'arrière-plan de l'option
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)',
    fontWeight: state.data.value,
    fontFamily: 'var(--sans-serif)', // Changer la couleur du texte de l'option
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)', // Changer la couleur de fond du menu déroulant
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const FontWeightInput = ({ name, value, onChange }) => {
  const fontWeights = [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
  ]

  const options = fontWeights.map((weight) => ({
    value: weight,
    label: weight,
  }))

  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name: name,
        value: selectedOption ? selectedOption.value : '',
      },
    })
  }

  const selectedOption = options.find((option) => option.value === value)

  return (
    <div className={styles.container}>
      <ReactSelect
        value={selectedOption}
        onChange={handleChange}
        options={options}
        className={styles.select}
        styles={customStyles}
      />
    </div>
  )
}

export default FontWeightInput
